import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

export default function Arrow(
    {
        animated = true
    }
) {
    // Create a ref for the path element
    const pathRef = useRef(null);

    const [currentAnimated,setCurrentAnimated]= useState(animated);

    /*
    useGSAP(() => {
        const path = pathRef.current;

        // Get the length of the path
        const pathLength = path.getTotalLength();

        // Set initial strokeDasharray and strokeDashoffset to hide the path
        gsap.set(path, {
            strokeDasharray: pathLength,
            strokeDashoffset: pathLength,
            fillOpacity: 0, // Initially make the fill invisible
        });

        if (animated) {
            // Animate the strokeDashoffset to 0 to "draw" the path
            gsap.to(path, {
                strokeDashoffset: 0,
                duration: 1, // Duration of the animation in seconds
                ease: "power1.inOut",
                onComplete: () => {
                    // Smoother fill-opacity transition to gradually show the fill
                    gsap.to(path, {
                        fillOpacity: 1, // Animate to full fill opacity
                        duration: 0.5, // Control the fill-opacity duration
                        ease: "power2.out", // Smoother easing function
                    });
                },
            });
        }
    }, [currentAnimated]);
    */

    useEffect(()=>{
        setCurrentAnimated(animated);
    },[animated])


    return (
        <svg width="100%" height="100%" viewBox="0 0 131 137" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                ref={pathRef} // Assign ref to the path element
                d="M3.49749 6.4177C1.2876 7.11592 0.0621419 9.4734 0.760356 11.6833C1.45857 13.8932 3.81606 15.1186 6.02595 14.4204L3.49749 6.4177ZM84.0703 131.054C83.9978 133.371 85.817 135.307 88.1334 135.38L125.882 136.56C128.198 136.633 130.135 134.813 130.207 132.497C130.28 130.181 128.461 128.244 126.144 128.172L92.59 127.122L93.6394 93.5679C93.7118 91.2515 91.8927 89.3149 89.5762 89.2425C87.2598 89.1701 85.3232 90.9892 85.2508 93.3056L84.0703 131.054ZM6.02595 14.4204C43.9432 2.44047 84.4482 12.3874 104.936 34.2271C115.064 45.0237 120.318 58.6946 118.201 74.3352C116.068 90.0973 106.366 108.424 85.3915 128.127L91.1376 134.244C112.983 113.724 124.043 93.7503 126.518 75.4608C129.01 57.0497 122.72 40.9174 111.057 28.4851C87.9628 3.86709 43.8966 -6.34639 3.49749 6.4177L6.02595 14.4204Z"
                fill="currentColor" // Set fill color to the current text color
                stroke="currentColor" // Add stroke color
                strokeWidth="0.25"
                fillOpacity="100" // Initially invisible fill
            />
        </svg>
    );
}
